<app-banner-app [retroSelected]="true"></app-banner-app>
<br><br><br><br><br><br>

<div class="container">
    <br><br>
    <div class="row">
        <div class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0">
            <div class="aliniacionTexto">
                <div class="aliniacionTexto">
                    <img class="styleImage img-responsive" src="./../../assets/img/Candado.png" />
                </div>
            </div>
        </div>

        <div class="col">
            <div class="container" style="text-align: center;">
                <span class="tipografiaCard">Contesta las siguientes preguntas para validar tu identidad</span><br>
                <span class="textoDetalleTipografia">
                    <br>
                    2 de 2 intentos restantes
                </span><br><br>
            </div>

            <div>
                <ol class="textoDetalleTipografia">
                    <li><span>
                            ¿Con qué entidad tuviste una cuenta de ahorros en los últimos seis meses?
                        </span>

                        <ul style="text-align: left;">
                            <li style="list-style-type: none;">
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="rbtOption" value="Numero1"
                                        style="border-color: #0033A0;">
                                    <label class="form-check-label tipValorTotal" for="rbt">Opcion 1
                                    </label>
                                </div>

                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="rbtOption" value="numero2"
                                        style="border-color: #0033A0;">
                                    <label class="form-check-label tipValorTotal" for="rbtNumero2">
                                        Opcion 1
                                    </label>
                                    <br>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <br>
                    <li>
                        <span>
                            ¿Cuál es es el departamento de expedición de tu documento de identidad?
                        </span>

                        <ul style="text-align: left;">
                            <li style="list-style-type: none;">
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="rbtOption" value="Numero1"
                                        style="border-color: #0033A0;">
                                    <label class="form-check-label tipValorTotal" for="rbt">
                                        Opcion 1
                                    </label>
                                </div>

                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="rbtOption" value="numero2"
                                        style="border-color: #0033A0;">
                                    <label class="form-check-label tipValorTotal" for="rbtNumero2">
                                        Opcion 1
                                    </label>
                                    <br>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <br>
                    <li>
                        <span>
                            ¿Con qué entidad cancelaste o saldaste una cuenta de ahorros en los últimos seis meses?
                        </span>

                        <ul style="text-align: left;">
                            <li style="list-style-type: none;">
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="rbtOption" value="Numero1"
                                        style="border-color: #0033A0;">
                                    <label class="form-check-label tipValorTotal" for="rbt">
                                        Opcion 1
                                    </label>
                                </div>

                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="rbtOption" value="numero2"
                                        style="border-color: #0033A0;">
                                    <label class="form-check-label tipValorTotal" for="rbtNumero2">
                                        Opcion 1
                                    </label>
                                    <br>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ol>


            </div>
            <br><br>

            <div style="width: 70%;" class="container">
                <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit">Continuar</button>
            </div>
        </div>
    </div>

</div>

<br><br><br>
<app-footer-app></app-footer-app>